module.exports = __webpack_public_path__ + "8ddadcc324ceb9fbcc0cc0a38c466779.png";